import { Col, Row, Descriptions, Typography } from "antd";
import React from "react";
import { Card } from "../../common/UIComponents";
import { groupDifferencesByAction } from "../AllOrgActivities/helper";
import { ellipseText } from "../../common/Common";
import I18n from "../../common/I18n";
const { Text, Paragraph } = Typography;

const getStyle = (oldValue, newValue) => {
  return oldValue !== newValue ? { backgroundColor: "yellow" } : {};
};

const fields = [
  { label: "Accessorial Name", key: "name" },
  { label: "Accessorial Code", key: "code" },
  { label: "GL Account Code", key: "gl_code" },
  { label: "EDI Code (X12)", key: "x12_edi_code" },
  { label: "Visibility", key: "visible_to" },
  { label: "Driver Pay Eligible", key: "eligible_for_driver_pay" },
  { label: "Includes Fuel Surcharge", key: "include_to_fuel_surcharge" },
  { label: "Counts as Attempt", key: "consider_for_attempt_driver" },
  { label: I18n.t('general.warehouse') + ' Required', key: "warehouse_operation" },
  { label: I18n.t('accessorials.order_level_accessorials'), key: "order_level_accessorials" },
  { label: "Consolidation Method", key: "consolidation_type" },
  { label: "Associated Components", key: "components" },
  { label: "Weight Units", key: "weight_units"}
];


const renderText = (value, type) => {
  const displayValue = !["N/A", "n/a", undefined, null, NaN, ""].includes(value)
    ? value
    : "N/A";
  if (type === "REMOVED") {
    return <Paragraph delete>{displayValue}</Paragraph>;
  }
  return <Text>{ellipseText(displayValue.replace(/_/g, " "), 10, true)}</Text>;
};

const renderRegularGroup = (changes, title, type) => {
  if (!changes?.length) return null;

  return (
    <div className="mb-6">
      <h4
        className="ant-typography ant-typography-md font-medium mb-3"
        style={{ textAlign: "left", fontSize: "16px" }}
      >
        {title}
      </h4>
      <Card
        style={{
          background: "#fff",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
          marginBottom: "16px",
          padding: "16px",
        }}
      >
        {changes.map((change, index) => {
          const oldConfig = change.old_value;
          const newConfig = change.new_value;
          return (
            <div key={index}>
              <Descriptions
                size="small"
                column={3}
                style={{ textAlign: "left" }}
              >
                {Object.keys(oldConfig || newConfig).map((key) => {
                  const fieldLabel =
                    fields.find((field) => field.key === key)?.label || key.replace(/_/g, " ");
                  return (
                    <Descriptions.Item label={fieldLabel} key={key}>
                      {renderText((oldConfig || newConfig)[key], type)}
                    </Descriptions.Item>
                  );
                })}
              </Descriptions>
            </div>
          );
        })}
      </Card>
    </div>
  );
};

const renderModifiedGroup = (changes) => {
  if (!changes?.length) return null;

  return (
    <div className="mb-6">
      <Card
        title={
          <h4
            className="ant-typography ant-typography-md font-medium mb-3"
            style={{ textAlign: "left", fontSize: "20px" }}
          >
            Modified Entries
          </h4>
        }
        style={{
          background: "#fff",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
          marginBottom: "16px",
          padding: "16px",
        }}
      >
        <Row gutter={32} type="flex">
          {changes.map((change, index) => {
            const oldConfig = change.old_value;
            const newConfig = change.new_value;
            const isModified = oldConfig && newConfig;

            return (
              <Col span={24} key={index}>
                <div>
                  {isModified ? (
                    <Row gutter={16} type="flex">
                      <Col span={24}>
                        <Card
                          title="Previous Entry"
                          style={{
                            background: "#f9f9f9",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
                            marginBottom: "16px",
                            padding: "16px",
                          }}
                        >
                          <Descriptions
                            column={3}
                            style={{ textAlign: "left" }}
                          >
                            {Object.keys(oldConfig).map((key) => {
                              const fieldLabel =
                                fields.find((field) => field.key === key)
                                  ?.label || key.replace(/_/g, " ");
                              return (
                                <Descriptions.Item
                                  label={fieldLabel}
                                  key={key}
                                >
                                  {renderText(oldConfig[key], "MODIFIED")}
                                </Descriptions.Item>
                              );
                            })}
                          </Descriptions>
                        </Card>
                      </Col>

                      {/* Modified Entry Card */}
                      <Col span={24}>
                        <Card
                          title="Modified Entry"
                          style={{
                            background: "#f9f9f9",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
                            marginBottom: "16px",
                            padding: "16px",
                          }}
                        >
                          <Descriptions
                            column={3}
                            style={{ textAlign: "left" }}
                          >
                            {Object.keys(newConfig).map((key) => {
                              const fieldLabel =
                                fields.find((field) => field.key === key)
                                  ?.label || key.replace(/_/g, " ");
                              return (
                                <Descriptions.Item label={fieldLabel} key={key}>
                                  <span style={getStyle(
                                    oldConfig[key],
                                    newConfig[key]
                                  )}>
                                  {renderText(newConfig[key], "MODIFIED")}
                                  </span>
                                </Descriptions.Item>
                              );
                            })}
                          </Descriptions>
                        </Card>
                      </Col>
                    </Row>
                  ) : (
                    <Card
                      title="Modified Entry"
                      style={{
                        background: "#f9f9f9",
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
                        marginBottom: "16px",
                        padding: "16px",
                      }}
                    >
                      <Descriptions
                        size="small"
                        column={4}
                        style={{ textAlign: "left" }}
                      >
                        {Object.keys(newConfig).map((key) => (
                          <Descriptions.Item label={key} key={key}>
                            {renderText(newConfig[key], "MODIFIED")}
                          </Descriptions.Item>
                        ))}
                      </Descriptions>
                    </Card>
                  )}
                </div>
              </Col>
            );
          })}
        </Row>
      </Card>
    </div>
  );
};

export const MainAccessorialDetails = ({ data }) => {
  const incomingData = data?.difference;
  const incomingAction = data?.action;
  const groupedDifferences = groupDifferencesByAction({
    action: incomingAction,
    difference: incomingData,
  });
  const incomingEntry = incomingData[0]?.new_value ? "New Entry" : "Old Entry";

  return (
    <Row gutter={[16, 32]}>
      <Col span={24}>
        <div className="mt-6">
          <h4
            className="ant-typography ant-typography-md font-medium mb-3"
            style={{ textAlign: "left", fontSize: "18px" }}
          >
            <span style={{ fontSize: "20px", color: "#395484" }}>
              Accessorials
            </span>
          </h4>
          <div className="mt-6">
            {renderRegularGroup(
              groupedDifferences.REMOVED,
              "Deleted Entry",
              "REMOVED"
            )}
            {renderRegularGroup(
              groupedDifferences.ADDED,
              incomingEntry,
              "ADDED"
            )}
            {renderModifiedGroup(groupedDifferences.MODIFIED)}
          </div>
        </div>
      </Col>
    </Row>
  );
};
